module.exports = __webpack_public_path__ + "src/assets/img/eng-stop-green.1d0fca9e.svg";